// Job query helpers: the shared active-count poll, the active-jobs list for the indicator, and invalidation after a job starts, changes or finishes of every job query and of the Datasets views whose build, preview or profile state comes from jobs.
import type { Query, QueryClient } from "@tanstack/react-query";

import {
  jobsGetActiveJobCountOptions,
  jobsListJobsOptions,
} from "@/api/__generated__/@tanstack/react-query.gen";

export const ACTIVE_COUNT_POLL_MS = 15_000;
export const ACTIVE_JOBS_POLL_MS = 5_000;
export const ACTIVE_JOBS_LIMIT = 10;

export function activeCountQueryOptions() {
  return { ...jobsGetActiveJobCountOptions(), refetchInterval: ACTIVE_COUNT_POLL_MS };
}

export function activeJobsQueryOptions() {
  return {
    ...jobsListJobsOptions({ query: { active: true, limit: ACTIVE_JOBS_LIMIT } }),
    refetchInterval: ACTIVE_JOBS_POLL_MS,
  };
}

const JOB_DERIVED = new Set([
  "operationsListRuns",
  "operationsListActivity",
  "datasetsListDatasets",
  "datasetsGetDatasetsOverview",
  "datasetsGetDocumentContents",
  "datasetsGetDatasetPreview",
  "registryListRegistryFamilies",
  "registryGetRegistryFamily",
  "registryGetRegistryVersion",
  "lifecycleListFamilyVersions",
  "registryListDatasetEvents",
  "uploadsListSourceFiles",
  "uploadsGetSourceFile",
  "uploadsGetSourceProfile",
]);

function isJobQuery(query: Query): boolean {
  const head = query.queryKey[0];
  return (
    head !== null &&
    typeof head === "object" &&
    "_id" in head &&
    typeof head._id === "string" &&
    (head._id.startsWith("jobs") || JOB_DERIVED.has(head._id))
  );
}

export async function invalidateJobQueries(queryClient: QueryClient): Promise<void> {
  await queryClient.invalidateQueries({ predicate: isJobQuery });
}
